export default {
  path: '/links',
  name: 'links',
  component: () => import('../components/link/Layout'),
  redirect: { name: 'LinkList' },
  children: [

  ]
};
